import { createSlice } from "@reduxjs/toolkit"
import { HYDRATE } from "next-redux-wrapper"

const initialState = {
  loading: false,
  productsResult: {},
}

export const vsresultSlice = createSlice({
  name: "vsresult",
  initialState: initialState,
  reducers: {
    updateVSResultData(state, { payload }) {
      state.productsResult = payload
    },
  },
  extraReducers(builder) {
    builder.addCase([HYDRATE], (state, action) => {
      return {
        ...state,
        ...action.payload,
      }
    })
  },
})

export const { updateVSResultData } = vsresultSlice.actions
export const selectvsresultState = state => state.vsresult

export default vsresultSlice.reducer
